import { Container, Text } from '@pixi/react'
import {
  GrayBackground,
  Image,
  Button,
  usePlayerStore,
  formatToCommaWithLang,
  toCommaOptions,
  useChipSetStore,
  soundManager,
  SoundType,
  useFeatureToggleStore, FeatureToggleType, t,
} from '@slot-nx/core'
import { gameConfig } from '../../config'
import { TextStyle } from 'pixi.js'
import { usePopupStore } from '../../domain/store/popupStore'
import { getPayStake } from '../../domain/buybonus/util/buyBonusUtil'
import { useGameStore } from '../../domain/game/store/GameStore'
import { useSelector } from '@xstate/react'
import { GameState, MachineActionType, sweetBombMachine } from '../../../machine/sweetbombMachine'
import { FreeGameType } from '../../domain/buybonus/enum/buyBonusEnum'
import { SweetBombSoundType } from '../../domain/soundManager/enum/soundType'

const commonTextStyle = new TextStyle({
  align: 'center',
  fontWeight: 'bold',
  dropShadow: true,
  dropShadowColor: '#000000',
  dropShadowBlur: 4,
  dropShadowAngle: Math.PI / 4,
  dropShadowDistance: 5,
})

const textTitleYellowStyle = new TextStyle({
  ...commonTextStyle,
  fill: '#FFBDDD',
  fontSize: 88,
})
const textTitleWhiteStyle = new TextStyle({
  ...commonTextStyle,
  fill: '#ffffff',
  fontSize: 120,
})

const textCurrencyStyle = new TextStyle({
  ...commonTextStyle,
  fill: '#F37EAB',
  fontSize: 48,
})
const textPayStyle = new TextStyle({
  ...commonTextStyle,
  fill: '#ffffff',
  fontSize: 72,
})

const oktextButtonStyle = new TextStyle({
  align: 'center',
  fontWeight: 'bold',
  fill: '#275107',
  fontSize: 40,
})

const cancelTextButtonStyle = new TextStyle({
  align: 'center',
  fontWeight: 'bold',
  fill: '#900707',
  fontSize: 40,
})

export const BuyBonusConfirmPopup = () => {
  const isOpenFreeGameConfirmPopup = usePopupStore(x => x.isOpenFreeGameConfirmPopup)
  const currency = usePlayerStore(x => x.currency)
  const currentFreeGameType = useGameStore.getState().currentFreeGameType
  const [currentIndex, chipSet] = useChipSetStore(x => [x.currentIndex, x.chipSet])
  const currentState = useSelector(sweetBombMachine, state => state.value)
  const featureToggle = useFeatureToggleStore(x => x.toggleList)
  const isDisableCurrencyDisplay = !featureToggle.get(FeatureToggleType.disableCurrencyDisplay)

  return isOpenFreeGameConfirmPopup
    ? (
        <GrayBackground name="BuyBonusConfirmPopup">
          <Container x={gameConfig.resolution.width / 2} y={gameConfig.resolution.height / 2}>
            <Image name="confirm box bg" image="confirmBoxBG" x={0} y={0} anchor={0.5} />

            <Text
              name="BigBuyTitle"
              text={t('buyFreeSpinConfirm_BigBuyTitle')}
              x={-160}
              y={-250}
              anchor={0}
              style={textTitleYellowStyle}
            />
            <Text
              text="10"
              x={70}
              y={-270}
              anchor={0}
              style={textTitleWhiteStyle}
            />
            <Text
              text={t('buyFreeSpinConfirm_FreeSpins')}
              x={0}
              y={-70}
              anchor={0.5}
              style={textTitleYellowStyle}
            />

            {isDisableCurrencyDisplay && (
              <Text
                text={currency}
                x={-280}
                y={24}
                anchor={0}
                style={textCurrencyStyle}
              />
            )}

            <Text
              name="pay stake"
              text={
                formatToCommaWithLang(getPayStake(chipSet[currentIndex], currentFreeGameType), navigator.language, toCommaOptions.maximumTwoDecimalPlaces)
              }
              x={-145}
              y={45}
              anchor={[0, 0.5]}
              style={textPayStyle}
            />

            <Button
              name="CancelButton"
              x={-320}
              y={140}
              enabled={true}
              visible={true}
              width={307}
              height={86}
              defaultView="btnCancelNormal"
              hoverView="btnCancelHover"
              disabledView="btnCancelUnable"
              pressedView="btnCancelClick"
              onPress={() => {
                soundManager.play(SoundType.buttonClose, { volume: 3 })
                usePopupStore.setState({
                  isOpenFreeGameConfirmPopup: false,
                })

                useGameStore.setState({
                  currentFreeGameType: FreeGameType.MainGame,
                })
              }}
            />

            <Button
              name="OkButton"
              x={25}
              y={140}
              enabled={true}
              visible={true}
              width={307}
              height={86}
              defaultView="btnOkNormal"
              hoverView="btnOkHover"
              disabledView="btnOkUnable"
              pressedView="btnOkClick"
              onPress={() => {
                soundManager.play(SweetBombSoundType.ButtonBuy, { volume: 3 })
                usePopupStore.setState({
                  isOpenFreeGameConfirmPopup: false,
                })

                if (currentState === GameState.mainGame) {
                  sweetBombMachine.send({ type: MachineActionType.placeOrder })
                }
              }}
            />

            <Text
              text={t('buyFreeSpinConfirm_Cancel')}
              x={-160}
              y={178}
              anchor={0.5}
              style={cancelTextButtonStyle}
            />
            <Text
              text={t('buyFreeSpinConfirm_Ok')}
              x={180}
              y={178}
              anchor={0.5}
              style={oktextButtonStyle}
            />
          </Container>
        </GrayBackground>
      )
    : null
}
